import React from 'react';

export default function ImageIconPng({
    style,
    src,
    alt = "Image Icon",
}) {
    return (
        <img
            style={style}
            src={src}
            alt={alt}
        />
    );
}